<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="1100px">
        <el-form size="small" :model="form" :label-width="formLabelWidth" ref="form">

            <div class="common-form">基本信息</div>
            <el-descriptions class="margin-top" title="" :column="3" size="medium" border>
                <el-descriptions-item>
                    <template slot="label">标题</template>
                    {{ detail.title ? detail.title : '' }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">课程类型</template>
                    {{ detail.course_type_desc ? detail.course_type_desc : '' }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">状态</template>
                    {{ detail.status_desc }}
                </el-descriptions-item>
                <el-descriptions-item v-if="detail.course_type === 1">
                    <template slot="label">停留时间</template>
                    {{ detail.watch_time }} 秒
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">学习人数</template>
                    {{ detail.students_num ? detail.students_num : 0 }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">封面</template>
                    <el-image style="height: 40px" fit="contain" v-if="detail.file_path" class="ya-img-table" :src="detail.file_path"
                              :preview-src-list="[detail.file_path]" title="点击查看大图"/>
                </el-descriptions-item>
            </el-descriptions>

            <div class="common-form" v-if="detail.course_type === 2">视频</div>
            <video ref="video" v-if="detail.course_type === 2" width="50%" height="50%" controls>
                <source :src="detail.video_url" type="video/mp4">
                <object :data="detail.video_url" width="100%" height="100%">
                    <embed :src="detail.video_url" width="100%" height="100%">
                </object>
            </video>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {courseDetail} from '@/api/education';

    export default {
        components: {},
        data() {
            return {
                title: '详情',
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,

                form: {},
                course_id: '',
                detail: []
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.$message({message: '获取详情失败', type: 'error'});
                } else {
                    this.course_id = row.course_id
                    this.getDetail()
                }
                this.detail.course_type = 1;
                this.dialogFormVisible = true
            },
            save() {
                this.close()
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                if(this.detail.course_type === 2){
                    this.$refs['video'].pause()
                }
                this.dialogFormVisible = false
            },
            getDetail() {
                courseDetail({id: this.course_id}).then((result) => {
                    this.detail = Object.assign({}, result.data)
                    if(this.detail.video_id > 0){
                        this.detail.video_url = result.data.video.file_path
                    }
                })
            },

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/course/course/detail.vue